module.exports = __webpack_public_path__ + "img/img-area-digital.a3ac1c0b.png";